import { Stack, Divider, Switch, IconButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setUserStandby } from 'src/redux/slices/user';
import { useSelector, useDispatch } from 'src/redux/store';
import { verifyRules } from 'src/utils/functions';
import Logo from 'src/components/Logo';
import useAuth from 'src/hooks/useAuth';
import NotificationsPopover from './NotificationsPopover';
import Iconify from 'src/components/Iconify';
import { setChatInfo } from 'src/redux/slices/chat';
import { setMessages } from 'src/redux/slices/staff';
import Label from 'src/components/Label';
import v2_actionEditarUsuario from 'src/actions/v2/usuarios/v2_actionEditarUsuario';
import { DropdownMenuDemo2 } from 'src/@/components/use/dropdownMenu/DropdownMenu2';
import { DropdownAccountNav } from 'src/@/components/use/dropdownMenu/DropdownAccountNav';
import { ZuiTooltip } from 'src/@/components/use/tooltip';
import { HelpComponent } from 'src/sections/@global/help';
import ContactsPopover from './ContactsPopover';
import { InternetConnectionAlertHeader } from 'src/sections/@global/connection/InternetConnectionAlertHeader';
import { getSpent } from 'src/helpers/cliente.helper';
import { LanguagePopover } from 'src/@/components/use/LanguagePopover';

DashboardNavbar.propTypes = {
    onOpenSidebar: PropTypes.func
};

export default function DashboardNavbar({ topOffset = 0 }) {
    const { user } = useAuth();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation('navigation');
    const { roomsWithNewMessages } = useSelector((state) => state.staff);
    const { isUserStandby } = useSelector((state) => state.user);
    const { flag } = useSelector((state) => state.global);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const soundNotification = localStorage.getItem('soundNotification');
    const [saldo, setSaldo] = useState(0);
    const [credit, setCredit] = useState(0);
    const [isLoadingSaldo, setIsLoadingSaldo] = useState(false);
    let location = useLocation();
    let path = location.pathname.substring(1); // Remove o "/" inicial

    const changeSoundNotification = (value) => {
        localStorage.setItem('soundNotification', value);
        window.location.reload();
    };

    async function handleEditStandbyUser(event) {
        let check = event.target.checked;
        dispatch(setUserStandby(check));
        let data = {
            action: "update_standby_users",
            scope: { userStandby: check }
        }
        await v2_actionEditarUsuario(user.id, data)
    }

    async function handleGetSaldo() {
        try {
            setIsLoadingSaldo(true);
            const hoje = new Date();
            const startDate = hoje.toISOString().split('T')[0];
            const endDate = hoje.toISOString().split('T')[0];
            const querys = `?inicio=${startDate}&final=${endDate}&periodo=mes_atual`;
            const response = await getSpent(user.clienteId, querys);
            // Calcula o saldo disponível (33% do limite restante)
            const limiteRestante = response?.data?.credits?.total?.limit - response?.data?.credits?.total?.use || 0;
            const saldoDisponivel = limiteRestante * 0.33;
            setSaldo(saldoDisponivel);
            setCredit(limiteRestante);
        } catch (error) {
            console.error('Erro ao buscar saldo:', error);
        } finally {
            setIsLoadingSaldo(false);
        }
    }

    useEffect(() => {
        handleGetSaldo();
    }, []);

    const atualizarSaldo = () => {
        handleGetSaldo();
    };

    const NavButton = ({ nome, slug, to, badge, icon, isMobile = false }) => {
        const isActive = path.includes(slug);
        return (
            <button onClick={() => { to(); if (isMobile) setIsMobileMenuOpen(false); }} className={`flex items-center px-2 py-1.5 rounded-lg transition-all duration-200 text-sm ${isActive ? 'bg-[#7C3AED]/10 text-[#7C3AED]' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'} ${isMobile ? 'w-full justify-start' : 'justify-center'}`} >
                <div className="flex items-center gap-2">
                    {/* <Iconify icon={icon} sx={{ width: 18, height: 18, color: isActive ? '#7C3AED' : 'inherit'}} /> */}
                    <span className={`whitespace-nowrap ${isMobile ? 'block' : 'hidden lg:block'}`}>
                        {nome}
                    </span>
                    {badge > 0 && (
                        <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-bold ${isActive ? 'bg-[#7C3AED] text-white' : 'bg-gray-200 text-gray-600'}`}>
                            {badge}
                        </span>
                    )}
                </div>
            </button>
        );
    };

    const NavigationItems = ({ isMobile = false }) => (
        <div className={`flex ${isMobile ? 'flex-col space-y-1' : 'flex-row space-x-1'}`}>
            {verifyRules(user.rules, "chats") && (
                <NavButton nome={t('sidebar.conversations')} slug="chats/chat" to={() => { navigate('/chats'); dispatch(setChatInfo(null)); dispatch(setMessages([])); }} badge={0} icon="ph:chats-circle-duotone" isMobile={isMobile} />
            )}
            {verifyRules(user.rules, "chat_interno") && (
                <NavButton nome={t('sidebar.internalChat')} slug="chats/interno" to={() => navigate('/chats/interno')} badge={roomsWithNewMessages.length} icon="iconoir:group" isMobile={isMobile} />
            )}
            {verifyRules(user.rules, "chamados") && (
                <NavButton nome={t('sidebar.funnel')} slug="dashboard/negocios" to={() => navigate('/dashboard/negocios')} badge={0} icon="iconamoon:funnel-thin" isMobile={isMobile} />
            )}
            <NavButton nome={t('sidebar.contacts')} slug="dashboard/contatos" to={() => navigate('/dashboard/contatos')} badge={0} icon="ph:address-book" isMobile={isMobile} />
            {verifyRules(user.rules, "chamados") && (
                <NavButton nome={t('sidebar.tickets')} slug="dashboard/chamados" to={() => navigate('/dashboard/chamados')} badge={0} icon="clarity:tasks-line" isMobile={isMobile} />
            )}
                <NavButton nome={t('sidebar.tarefas')} slug="dashboard/tarefas" to={() => navigate('/dashboard/tarefas')} badge={0} icon="ph:task" isMobile={isMobile} />
       
        </div>
    );

    return (
        <header
            className="fixed z-10 w-full border-b border-gray-200 bg-white backdrop-blur-sm transition-all duration-300"
            style={{ top: topOffset }}
        >
            {flag?.status && (
                <div className={`flex w-full bg-${flag?.flag}-600 h-8 items-center justify-center text-xs font-medium text-white px-4`}>
                    {flag?.msg}
                </div>
            )}
            <div className="flex h-14 items-center px-4 w-full justify-between">
                {/* Logo & Mobile Menu & Nav */}
                <div className="flex items-center gap-4">
                    <div className='flex items-center gap-4'>
                        <Logo />
                        <div className="h-6 w-[1px] bg-gray-200 hidden md:block" />
                    </div>
                    <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2 text-gray-500 hover:bg-gray-100 rounded-lg transition-colors">
                        <Iconify icon={isMobileMenuOpen ? "heroicons:x-mark" : "heroicons:bars-3"} width={24} />
                    </button>
                    <div className="hidden md:flex">
                        <NavigationItems />
                    </div>
                    <div className="hidden md:block">
                        <DropdownMenuDemo2 />
                    </div>
                </div>
                {/* Right Actions */}
                <div className="flex items-center gap-2 md:gap-3">
                    <InternetConnectionAlertHeader />
                    <ZuiTooltip content={
                        <div className="space-y-1 p-1">
                            <div className="font-semibold text-xs text-gray-900">{t('navbar.credits')}</div>
                            <div className="text-[10px] text-gray-500 space-y-0.5">
                                <div>{t('navbar.balance')}: <span className="font-medium text-gray-700">{credit}</span> {t('navbar.credits').toLowerCase()}</div>
                                <div>{t('navbar.status')}: <span className={saldo < 0 ? 'text-red-500' : 'text-green-600'}>{saldo < 0 ? t('common:status.negative') : t('common:status.positive')}</span></div>
                            </div>
                        </div>
                    }
                    >
                        <div className={`flex items-center gap-2 px-3 py-1 rounded-lg border transition-all duration-200 ${saldo < 0 ? 'bg-red-50 border-red-100 text-red-600' : 'bg-indigo-50 border-indigo-100 text-indigo-600 hover:bg-indigo-100'}`}>
                            <button onClick={() => navigate('/dashboard/conta/consumo')} className="flex items-center gap-1.5">
                                <Iconify icon="solar:wallet-bold-duotone" width={16} />
                                <span className="text-xs font-semibold">{credit}</span>
                            </button>
                            <button onClick={(e) => { e.stopPropagation(); atualizarSaldo(); }} className={`p-0.5 rounded-full hover:bg-black/5 disabled:opacity-50`} disabled={isLoadingSaldo} >
                                <Iconify icon="lucide:refresh-cw" width={12} className={isLoadingSaldo ? 'animate-spin' : ''} />
                            </button>
                        </div>
                    </ZuiTooltip>
                    {/* <ZuiTooltip content={
            <div className="space-y-1 p-1 bg-slate-50">
              <div className="font-semibold text-xs text-gray-900">Status de Disponibilidade</div>
              <div className="text-[10px] text-gray-500">
                {isUserStandby ? "Você está ausente e não receberá novos chats." : "Você está online e disponível para atendimentos."}
              </div>
              <div>
                Clique no icone para alterar o status
              </div>
            </div>
          }
          >
            <button onClick={() => handleEditStandbyUser({ target: { checked: !isUserStandby } })} className={`hidden md:flex items-center gap-2 p-1 rounded-sm border transition-all duration-300 ${isUserStandby ? 'bg-red-50 hover:bg-red-100' : 'bg-green-50 hover:bg-green-100'}`} >
              <Iconify icon={"fluent:person-support-20-filled"} className={`${isUserStandby ? 'text-red-400' : 'text-green-400'} w-[20px] h-[20px]`} />
            </button>
          </ZuiTooltip> */}
                    <div className="h-6 w-[1px] bg-gray-200 hidden md:block" />
                    <div className="flex items-center gap-1">
                        <IconButton onClick={() => changeSoundNotification(soundNotification === "true" ? "false" : "true")} className="h-9 w-9 text-gray-500 hover:bg-gray-100 hover:text-gray-900 rounded-lg transition-colors p-0">
                            <Iconify icon={soundNotification === "true" ? "solar:volume-loud-bold-duotone" : "solar:volume-cross-bold-duotone"} width={20} />
                        </IconButton>
                        {/* <ContactsPopover /> */}
                        <NotificationsPopover />
                        <HelpComponent />
                        <LanguagePopover />
                    </div>
                    <div className="h-6 w-[1px] bg-gray-200 hidden md:block" />
                    <DropdownAccountNav />
                </div>
            </div>
            {isMobileMenuOpen && (
                <div className="md:hidden absolute top-14 left-0 w-full bg-white border-b border-gray-100 shadow-xl z-40 animate-in slide-in-from-top-2 duration-200">
                    <div className="p-4 space-y-4">
                        <div className="space-y-1">
                            <Typography variant="overline" className="text-gray-400 pl-2">{t('common:menu')}</Typography>
                            <NavigationItems isMobile={true} />
                        </div>
                        <Divider className="border-gray-100" />
                        <div className={`rounded-xl p-3 border ${isUserStandby ? 'bg-amber-50 border-amber-100' : 'bg-green-50 border-green-100'}`}>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <div className={`p-2 rounded-full ${isUserStandby ? 'bg-amber-100 text-amber-600' : 'bg-green-100 text-green-600'}`}>
                                        <Iconify icon={isUserStandby ? "solar:coffee-bold-duotone" : "solar:user-check-bold-duotone"} width={20} />
                                    </div>
                                    <div>
                                        <p className={`text-sm font-semibold ${isUserStandby ? 'text-amber-900' : 'text-green-900'}`}>
                                            {isUserStandby ? t('account.awayMode') : t('account.onlineMode')}
                                        </p>
                                        <p className={`text-xs ${isUserStandby ? 'text-amber-700' : 'text-green-700'}`}>
                                            {isUserStandby ? t('account.awayInfo') : t('account.onlineInfo')}
                                        </p>
                                    </div>
                                </div>
                                <Switch checked={isUserStandby} onChange={handleEditStandbyUser} color={isUserStandby ? "warning" : "success"} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </header>
    );
}